<template>
    <div>
        <kgr-loading v-if="loading" />
        <div
            v-else
            class="chart"
        >
            <highcharts :options="chartOptions" />
        </div>
    </div>
</template>

<script>
import ClubStatsRepository from '../../../js/repository/ClubStatsRepository';
import Loading from '../../common/Loading.vue';

export default {
    name: 'MemberLoginOverview',
    components: {
        'kgr-loading': Loading,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            chartOptions: {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie'
                },
                title: {
                    text: this.$t('club.stats.memberLogin.title'),
                },
                tooltip: {
                    width: 50,
                    pointFormat: '<span class="kgr-text--bold">{point.y}</span> ' + this.$t('Mitglieder') + '<br>' +
                        '<span class="kgr-text--bold">{point.percentage:.1f} %</span><br>' +
                        '{point.description}'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '<span class="kgr-text--bold">{point.name}</span>: {point.y}',
                            style: {
                                fontWeight: 'var(--kgr-font-weight-normal)'
                            }
                        },
                    }
                },
                series: [{
                    name: '',
                    colorByPoint: true,
                    data: []
                }],
                credits: {
                    enabled: false
                },
                legend: {
                    align: 'right',
                    layout: 'vertical',
                    verticalAlign: 'top',
                    y: 15,
                },
            }
        }
    },
    mounted() {
        this.loadMemberLoginData();
    },
    methods: {
        loadMemberLoginData() {
            ClubStatsRepository.getMemberLoginData(this.clubId)
                .then(stats => {
                    let total = stats['total'];
                    let confirmed = stats['confirmed'];
                    let unconfirmed = total - confirmed;

                    this.chartOptions.title.text = this.$t('club.stats.memberLogin.title', { 'num': total});
                    this.chartOptions.series[0].data = [
                        {
                            name: 'bestätigt',
                            y: confirmed,
                            description: this.$t('club.stats.memberLogin.label.confirmed'),
                        },
                        {
                            name: 'nicht bestätigt',
                            y: unconfirmed,
                            description: this.$t('club.stats.memberLogin.label.unconfirmed'),
                        },
                    ];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
}

</script>

<style scoped>

</style>
